var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.405273,
    width: 41.1899,
    height: 41.1899,
    rx: 18.3003,
    fill: "#F4A51D",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4674 12.0478C22.4158 12.0443 22.3639 12.0425 22.3118 12.0425H17.2591C15.073 12.0425 13.3008 13.8147 13.3008 16.0008V26.0008C13.3008 28.1869 15.073 29.9591 17.2591 29.9591H23.9258C26.1119 29.9591 27.8841 28.1869 27.8841 26.0008V18.2925H24.7591C23.4935 18.2925 22.4674 17.2665 22.4674 16.0008V12.0478ZM16.6341 21.0008C16.6341 20.6556 16.9139 20.3758 17.2591 20.3758H23.9258C24.271 20.3758 24.5508 20.6556 24.5508 21.0008C24.5508 21.346 24.271 21.6258 23.9258 21.6258H17.2591C16.9139 21.6258 16.6341 21.346 16.6341 21.0008ZM17.2591 24.5425C16.9139 24.5425 16.6341 24.8223 16.6341 25.1675C16.6341 25.5127 16.9139 25.7925 17.2591 25.7925H20.5924C20.9376 25.7925 21.2174 25.5127 21.2174 25.1675C21.2174 24.8223 20.9376 24.5425 20.5924 24.5425H17.2591Z",
    fill: "#F4A51D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5271 17.0425C27.4745 16.9596 27.4164 16.8799 27.353 16.8038L24.0723 12.8671C23.9657 12.7392 23.8466 12.6245 23.7174 12.5242V16.0008C23.7174 16.5761 24.1838 17.0425 24.7591 17.0425H27.5271Z",
    fill: "#F4A51D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.f1bcf1d5a36f2225f5d380631a5f7908.svg";
export { ForwardRef as ReactComponent };